import { useEffect, useState } from 'react';
import { adminApi } from '../../api/admin.js';

export default function SystemHealth() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  function refresh() {
    adminApi.health().then(setData).catch((err) => setError(err.response?.data?.message || 'Failed'));
  }
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 15_000);
    return () => clearInterval(t);
  }, []);

  if (error) return <div className="alert error">{error}</div>;
  if (!data) return <div className="muted">Loading…</div>;

  return (
    <section>
      <header className="page-header"><h1>System Health</h1></header>
      <div className="kpi-row">
        <Kpi label="Status" value={data.status} cls={data.status === 'ok' ? 'positive' : 'warn'} />
        <Kpi label="Database" value={`${data.services.database.latency_ms ?? '—'} ms`} cls={data.services.database.ok ? 'positive' : 'negative'} />
        <Kpi label="Redis" value={`${data.services.redis.latency_ms ?? '—'} ms`} cls={data.services.redis.ok ? 'positive' : 'negative'} />
        <Kpi label="Uptime" value={`${Math.floor(data.runtime.uptime_s / 3600)}h ${Math.floor((data.runtime.uptime_s % 3600) / 60)}m`} />
        <Kpi label="Memory" value={`${data.runtime.memory_mb} MB`} />
        <Kpi label="Node" value={data.runtime.node} />
      </div>

      <div className="grid-2">
        <div className="card">
          <h3>Workflow queue</h3>
          <div className="big-stat">{data.queues.workflow_pending_steps}</div>
          <p className="muted small">pending instance steps awaiting action</p>
        </div>
        <div className="card">
          <h3>Webhook deliveries</h3>
          <p>Pending: <strong>{data.queues.webhook_pending}</strong></p>
          <p>Failed: <strong className={data.queues.webhook_failed > 0 ? 'negative' : ''}>{data.queues.webhook_failed}</strong></p>
        </div>
      </div>

      <p className="muted small">Auto-refreshing every 15 seconds.</p>
    </section>
  );
}

function Kpi({ label, value, cls }) {
  return (
    <div className="kpi">
      <div className="kpi-label">{label}</div>
      <div className={`kpi-value ${cls || ''}`}>{value}</div>
    </div>
  );
}
